import { createSelector } from 'reselect'

import { selectPartner360Data } from './selectPartner360Data'

export const selectOutOfScope = createSelector(
  [selectPartner360Data],
  ({ outOfScope }) => outOfScope
)
